"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPeerDescriptorSignaturePayload = void 0;
const DhtRpc_1 = require("../../generated/packages/dht/protos/DhtRpc");
function convertUnsignedIntegerToBuffer(number) {
    const buffer = Buffer.alloc(4);
    buffer.writeUInt32BE(number);
    return buffer;
}
const createPeerDescriptorSignaturePayload = (peerDescriptor) => {
    const separator = Buffer.from(',');
    const buffers = [
        peerDescriptor.type !== undefined ? convertUnsignedIntegerToBuffer(peerDescriptor.type) : new Uint8Array(0),
        separator,
        peerDescriptor.udp !== undefined ? DhtRpc_1.ConnectivityMethod.toBinary(peerDescriptor.udp) : new Uint8Array(0),
        separator,
        peerDescriptor.tcp !== undefined ? DhtRpc_1.ConnectivityMethod.toBinary(peerDescriptor.tcp) : new Uint8Array(0),
        separator,
        peerDescriptor.websocket !== undefined ? DhtRpc_1.ConnectivityMethod.toBinary(peerDescriptor.websocket) : new Uint8Array(0),
        separator,
        peerDescriptor.region !== undefined ? convertUnsignedIntegerToBuffer(peerDescriptor.region) : new Uint8Array(0),
        separator,
        peerDescriptor.ipAddress !== undefined ? convertUnsignedIntegerToBuffer(peerDescriptor.ipAddress) : new Uint8Array(0),
        separator,
        peerDescriptor.publicKey !== undefined ? Buffer.from(peerDescriptor.publicKey) : new Uint8Array(0)
    ];
    return Buffer.concat(buffers);
};
exports.createPeerDescriptorSignaturePayload = createPeerDescriptorSignaturePayload;
//# sourceMappingURL=createPeerDescriptorSignaturePayload.js.map